export const rewardsRedesign = {
    cookieFlagName: 'DP_REWARDS_REDESIGN',
    headerFlagName: 'X-REWARDS-REDESIGN',
};

export const keepMeLoggedIn = {
    cookieFlagName: 'DP_ENABLE_KEEP_ME_LOGGEDIN',
    headerFlagName: 'X-ENABLE-KEEP-ME-LOGGEDIN',
};

export const plccBanner = {
    cookieFlagName: 'DP_ENABLE_PAYMENTS_PLCC_BANNER',
    headerFlagName: 'X-ENABLE-PAYMENTS-PLCC-BANNER',
};

export const keyFeatureConsts = {
    minIconsCount: 2,
    maxIconsCount: 9,
};

export const barcode = {
    modalTitle: 'Use Your Rewards',
    modalHeading:
        'To Redeem in-store, present barcode to the cashier. Some <a href="www.jcpenney.com">exclusions</a> may apply.',
    modalButtonTitle: 'Print',
    type: {
        JCPMASTER: ['MCCERT', 'MASTERCARD RWD'],
    },
    images: {
        MASTERCARD: '/static-account/assets/images/mc-vrt-pos.svg',
        BONUSBUCKS: '/static-account/assets/images/bonus-bucks-cert-header.svg',
        BG_LG_BONUSBUCKS: '/static-account/assets/images/bonus-bucks-bg-xl.svg',
    },
};
export const createAccountErrorMessages = {
    EMPTY_INPUT_ERROR: 'Please enter valid password',
    NON_ALLOWED_SPECIALS_ERROR: 'Not all special characters are allowed',
    MISC_CHARS_ERROR:
        'Password cannot have name, email, penney, jcp or jcpenney, 3+ consecutive characters',
    MINIMUM_REQ_NOT_MET_ERROR: 'Password does not meet requirements',
};
export const cookie = {
    // Cookie names
    LATLONG: '_userLoc',
    PRICE_ZONE: 'UPZ',
    previewDate: 'DP_PREVIEW_DATE',
};

export const rewardsPersonalization = {
    REWARD_AVAILABLE: 'Reward Available',
    REWARDS_MEMBER: 'Rewards Member',
    DP_REWARDS_DETAILS: 'DP_REWARDS_DETAILS',
    POINTS: 'points',
    MY_ACCOUNT: 'My Account',
    EARNED_POINT_THRESHOLD: 50,
};

export const SIGNIN = 'Sign In';
export const SIGNIN_CREATEACCOUNT = 'Sign In | Create Account';
export const ENROLLED = 'enrolled';

export const googleMapAPIConfig = {
    API_URL: '//maps.googleapis.com/maps/api/js?key=',
    API_KEY: 'AIzaSyDc0dnG9cxE3N1wqkqY8_iumInyqrAR1bU',
    API_LIBRARY_PARAM_NAME: 'libraries',
    API_PLACE_LIBRARY: 'places',
    AUTO_COMPLETE_ID: 'autocomplete',
    AUTO_COMPLETE_ADDRESS_TYPE_STREET_NUMBER: 'street_number',
    AUTO_COMPLETE_ADDRESS_TYPE_STREET_NAME: 'route',
    AUTO_COMPLETE_ADDRESS_TYPE_POST_CODE: 'postal_code',
    AUTO_COMPLETE_ADDRESS_TYPE_STATE: 'administrative_area_level_1',
    AUTO_COMPLETE_ADDRESS_TYPE_CITY: 'locality',
    AUTO_COMPLETE_ADDRESS_TYPE_SUB_LOCALITY: 'sublocality_level_1',
    AUTO_COMPLETE_ADDRESS_FIELDS: ['name', 'address_components'],
};
export const findStoreErrorMessages = {
    LOCATION_ERROR_MSG_TITLE: 'Location services error',
    LOCATION_NOT_ENABLED:
        'Please enter your Zip Code or City, State, since location services are not enabled due to browser or privacy settings.',
    GEO_LOCATE_ERROR: 'There was an error with location services, please enter your location',
    EMPTY_ZIP_CODE: 'Please enter a valid zipcode or choose use my location',
    FUSION_EMPTY_ZIP_CODE: 'Please enter a valid zipcode',
    ZIP_CODE_ERROR: 'Zip code must be 5 digits',
};
export const geoErrorType = {
    GEO_LOCATE_ERROR: 'geoLocateError',
    GEO_UNAVAILABLE: 'geoUnavailable',
    EMPTY_ZIP_CODE: 'emptyZipCode',
    NOT_SUPPORTED: 'browserNotSupported',
    TIMED_OUT: 'timeout',
    AKAMAI_LOCATE_ERROR: 'AkamaiLocateError',
};
export const useLocationLabel = 'Use My Location';
export const couponBodyCopy = 'Show coupon to sales associate';
export const couponErrorMessages = {
    COUPON_CODE_MISSING: 'Please enter a valid code.',
    INPUT_BOX_PLACEHOLDER: 'Enter promo code...',
    CODE_DOES_NOT_EXIST: 'Code does not exist.',
    COUPON_REQUEST_ERROR:
        'Oops! There is an error on our end. Please try to apply the coupon again.',
    SRV_REWARD_TOKEN_MISSING:
        'Oops! There is an error on our end. Please try to apply the coupon again.',
    COUPON_CODE_EXPIRED:
        'Oh no! The code you typed in has already expired. Please apply an eligible coupon.',
    SRV_COUPON_EXPIRED_ERR:
        'Oh no! The code you typed in has already expired. Please apply an eligible coupon.',
    SERIAL_NUMBER_REQUIRED: 'Serial Number Required.',
    SERIAL_NUMBER_REQ_MESSAGE:
        'This code requires a serial number. Please type in the serial number shown on your coupon or reward.',
    IRIS_COUPON_NO_CART_ITEMS:
        'Oops! We cannot apply this coupon because your cart is empty. We can apply this coupon code once you add an item to your bag.',
    SRV_PROMOCODE_INVALID:
        'Oh no! The code you applied has already expired. Please apply an eligible coupon.',
};
export const couponDrawerErrorMessages = {
    COUPON_REQUEST_ERROR: [
        'Oops! There is an error on our end.',
        'Please try to apply the coupon again.',
    ],
    COUPON_CODE_EXPIRED: [
        'Coupon code {COUPONCODE} has already expired.',
        'Please apply an eligible coupon.',
    ],
    SRV_COUPON_EXPIRED_ERR: [
        'Coupon code {COUPONCODE} has already expired.',
        'Please apply an eligible coupon.',
    ],
    SERIAL_NUMBER_REQ_MESSAGE: [
        'Coupon code {COUPONCODE} requires a serial number.',
        'Enter the serial number shown on your coupon or reward.',
    ],
    SRV_PROMOCODE_INVALID: [
        "We don't recognize coupon code {COUPONCODE}.",
        'Please apply an eligible coupon.',
    ],
    IRIS_COUPON_NO_CART_ITEMS: [
        "We can't apply this coupon just yet.",
        'Start shopping and add this coupon when you have an item in the cart.',
    ],
    SRV_REWARD_TOKEN_MISSING: [
        'Oops! There is an error on our end.',
        'Please try to apply the coupon again.',
    ],
};
export const COUPON_SUBTYPE_PROMOTIONAL = 'PROMOTIONAL';
export const COUPON_SUBTYPE_SHIPPING = 'SHIPPING';
export const COUPON_APPLIED_SUCCESS = 'This coupon has been applied to your cart.';
export const CONTINUE_SHOPPING_LABEL = 'Continue Shopping';
export const IRIS_CONTINUE_SHOPPING_LABEL = 'Shop Sales';
export const COUPON_APPLIED_SHOP_NOW_LABEL = 'Shop Now';
export const COUPONS_APPLIED_LABEL = 'Coupon Applied';
export const COUPONS_APPLIED_LABEL_EXCLUSION = 'Coupon Applied to Cart';
export const COUPONS_UPDATE_LABEL = 'Coupon Updated';
export const REWARDS_APPLIED_LABEL = 'Reward Applied';
export const CHECKOUT_LABEL = 'Checkout';
export const SERIAL_APPLY_LABEL = 'Apply Number';
export const COUPONS_NO_CODE_REQUIRED = 'NO CODE NECESSARY';
export const couponToggleDetails = {
    COUPONS_SHOW_DETAILS: 'Show Details',
    COUPONS_HIDE_DETAILS: 'Hide Details',
    IRIS_COUPON_DETAILS: 'see details',
};
export const COUPON_EMPTYCART_LABEL = 'Cannot Apply Coupon';
export const IRIS_COUPON_EMPTYCART_LABEL = 'Your Cart is Empty';
export const CouponCategory = {
    all: 'online & in store',
    inStore: 'in store only',
    onlineOnly: 'online only',
};
export const CouponCategories = {
    all: 'Online & In Store',
    instore: 'In Store Only',
    online: 'Online Only',
};
export const CouponTypes = {
    APPLIED: 'Applied',
    SERIAL: 'Serial',
    BARCODE: 'Barcode',
};
export const couponPrintCheck = ['print', 'print coupon'];
export const adjustmentType = {
    COUPON: 'COUPON',
    REWARD: 'REWARDSCERT',
    FREESHIP: 'CouponSHFree',
    ASSOC_DISCOUNT: 'ASSOCIATEDISCOUNT',
};
export const CouponRedeemingChannel = {
    ALL: 'all',
    IN_STORE: 'instore',
    ONLINE_ONLY: 'online',
};
export const CouponFindStoreLabel = 'find a store';
export const CouponShopNowLabel = 'shop now';
export const CouponPrintLabel = 'Print';
export const IRISCouponPrintLabel = 'Print Barcode';
export const CouponAppledMethod = {
    INPUT_COUPON: 'manual',
    SELECT_COUPON: 'selected from list',
};
export const findStores = {
    API_LIBRARY_PARAM_NAME: 'libraries',
    API_PLACE_LIBRARY: 'places',
    API_URL: '//maps.googleapis.com/maps/api/js?key=',
    BOPISDefaultMessage:
        'No results found. Please make sure you entered a valid city, state, or ZIP Code.',
    BOPISEligibleError:
        'Sorry, there are no stores in the area with the item(s) available for Same Day Pickup.',
    BOPISGeoError: 'Please provide your city and state, or ZIP Code.',
    BOPISInvalidInputError:
        'Sorry, there are no stores nearby. Just in case, make sure you entered a valid city, state, or ZIP Code.',
    GOOGLE_API_KEY: 'AIzaSyCXssOmw3AgN0U-STMPbASl28ymrK4We2U', // TODO remove this key once enableGeocoder went 100%
    INVALID_INPUT: 'INVALID_INPUT',
    LINK: 'Link',
    SELECT_STORE: 'Select Store',
    STORES_COUNT: 'X-Total-Count',
    Unavailable: 'Unavailable',
    account: { detailsButton: 'Set My Store' },
    changeMyStorePageTitle: 'Change My Store',
    curbsideAvailable: 'Curbside Available',
    defaultTitle: 'Enter a City, State or Zip Code to find the closest JCPenney store.',
    filterHeader: 'Filter by Services',
    filterHeaderNew: 'Filter By',
    findAStorePageTitle: 'Find A Store',
    invalidInputContent: 'Please make sure you entered a valid zip code or city, state.',
    invalidInputMsg: 'Please enter valid city, state or ZIP code',
    newOrderMessage: 'Order by 3PM and get it today',
    noSDPUStoresMessage:
        "We're sorry…there are no JCP stores in that location with the item(s) available for Same Day Pickup.",
    noSDPUStoresTitle:
        'Sorry, there are no JCP stores in that location with the item(s) available for Same Day Pickup.',
    noStorePageContent: 'Please make sure you entered a valid zip code or city, state.',
    noStorePageTitle: "Sorry, we couldn't find any stores near your search.",
    noStoresMessage: "We're sorry...we couldn't find any jcp stores that match your search",
    order: { detailsButton: 'Select' },
    orderMessage: 'Same day pickup items ordered after 3 PM will be available the next day',
    pageSize: 7,
    pdpFindStoresPageSize: 25,
    selectAStoreHeaderText: 'Select a Store',
    selectAStorePageTitle: 'Select A Store',
    selectThisStore: 'Select This Store',
};
export const searchMaps = {
    GOOGLE_MAPS_URL: 'https://www.google.com/maps/dir/?api=1&destination=',
    APPLE_MAPS_URL: 'https://maps.apple.com?address=',
};
export const GENERIC_API_ERROR_MESSAGE =
    'There was an error while processing your request. Please try again.';
export const COUPON_TYPEAHEAD_TRIGGER_LENGTH = 3;
export const IN_STORE_ONLY_COUPONS = 'INSTOREONLYCOUPONS';
export const ACCESS_TOKEN = 'Access_Token';
export const REFRESH_TOKEN = 'Refresh_Token';
export const ACCOUNT_ID = 'ACCOUNT_ID';
export const DP_USER_STATE = 'DP_USER_STATE';
export const DP_APPLY_SYF = 'DP_APPLY_SYF';
export const DP_FIRST_NAME = 'DP_FIRST_NAME';
export const DP_USER_NAME = 'DP_USER_NAME';
export const DP_REWARDS_STATUS = 'DP_REWARDS_STATUS';
export const DP_REWARDS_CERTS = 'DP_REWARDS_CERTS';
export const DP_SAVED_ITEMS_COUNT = 'DP_SAVED_ITEMS_COUNT';
export const DP_SAVED_ITEMS = 'DP_SAVED_ITEMS';
export const DP_HAS_JCP_CARD = 'DP_HAS_JCP_CARD';
export const DP_JCP_CARD = 'DP_JCP_CARD';
export const ANALY_CUST_STATE = 'ANALY_CUST_STATE';
export const ANALY_LOGIN = 'logged-in';
export const ANALY_GUEST = 'guest';
export const ANALY_LOGIN_RECOG = 'logged-in|recognized';
export const ANALY_RECOG_LOGIN = 'recognized|logged-in';
export const ANALY_RECOG_GUEST = 'recognized|guest';
export const DP_CHECKOUT_SAVED_ITEMS = 'DP_CHECKOUT_SAVED_ITEMS';
export const DP_CHECKOUT_SAVED_ITEMS_PAYLOAD = 'DP_CHECKOUT_SAVED_ITEMS_PAYLOAD';
export const DP_USER_TOKEN = 'DP_USER_TOKEN';
export const DP_SAVED_ITEMS_PAYLOAD = 'DP_SAVED_ITEMS_PAYLOAD';
export const DP_VISITOR_ID = 'DP_VISITOR_ID';
export const DP_USER_DEFAULT_STORE = 'DP_USER_DEFAULT_STORE';
export const DEFAULT_STORE = 'defaultStore';
export const DP_SFL_ID = 'DP_SFL_ID';
export const TOKEN_API_STATUS = 'TOKEN_API_STATUS';
export const DEFAULT_CURRENCY = 'USD';
export const ITEM_COUNT = 'ItemCount';
export const DESKTOP_ITEM_COUNT = 'DP_ORDER_INFO';
export const DP_FULL_ACCESS_EXPIRY = 'DP_FULL_ACCESS_EXPIRY';
export const analytics = {
    COUPON_APPLIED_SUCCESS: 'COUPON_APPLIED_SUCCESS',
    SELECT_STORE_SUCCESS: 'SELECT_STORE_SUCCESS',
};
export const branchio = {
    BRANCHIO_TEST_KEY: 'key_test_mlBoOH9ybO7NGpeCWvvNTegaBtev2hgv',
    BRANCHIO_LIVE_KEY: 'key_live_ekymMOXuhN0OGkfD1ytRmhmluEozYgdl',
};
export const OK_LABEL = 'OK';
export const CART_PAGE_URL = '/cart';
export const CART_PAGE_URL_LIST = [
    '/cart',
    '/cart/signin',
    '/cart/resetpassword',
    '/cart/giftcard',
];
export const CHECKOUT_PAGE_URL = '/checkout';
export const ACCOUNT_LOCKED_PAGE_URL = '/checkout/account-locked';
export const CART_YODA_EXPERIENCE = 'OFF';
export const CLASSIC_CART_PAGE_URL = '/cart#/';
// =Constants for error message handling. Don't remove them;
export const SET_SERVICE_ERROR = 'SET_SERVICE_ERROR';
export const CLEAR_SERVICE_ERROR = 'CLEAR_SERVICE_ERROR';
export const GENERIC_API_ERROR = 'GENERIC_API_ERROR';
export const INITIATE_CHECKOUT_AGAIN = 'INITIATE_CHECKOUT_AGAIN';
export const SRV_ITEM_NOT_FOUND = 'SRV_ORD_ERR_ITM_NF';
export const SRV_COMMERCE_ITEMNOTFOUND = 'SRV_COMMERCE_ITEMNOTFOUND';
export const SRV_PROMOTION_NOTFOUND = 'SRV_PROMOTION_NOTFOUND';
export const ACTION_NOT_ALLOWED_FOR_RECOGNIZED = 'ACTION_NOT_ALLOWED_FOR_RECOGNIZED';
export const SRV_BILLING_ADDRESS_INVALID = 'SRV_BILLING_ADDRESS_INVALID';
export const SRV_ORDER_EMAILNOTFOUND = 'SRV_ORDER_EMAILNOTFOUND';
export const ADD_TO_REGISTRY_MESSAGES_ID = 'ADD_TO_REGISTRY_MESSAGES_ID';
export const findStoreThemes = {
    findAStorePage: 'findAStorePage',
    gallery: 'gallery',
    selectAStore: 'selectAStore',
    pdpMajorAppliances: 'pdpMajorAppliances',
    visitStoreToPurchase: 'visitStoreToPurchase',
    pdp: 'pdp',
    checkoutShipping: 'checkoutShipping',
};
export const SRV_PRODUCT_NOTFOUND = 'SRV_PRODUCT_NOTFOUND';
export const SRV_REFRESH_TOKEN_EXPIRED = 'SRV_REFRESH_TOKEN_EXPIRED';
export const GUEST_USER = 'GUEST_USER';
export const APPLIANCE_MESSAGE_TITLE =
    'Major Appliances are available for purchase nationwide. You can place an order on jcp.com, in an area store(see below), or call 1-844-JCP-APPL(1-844-527-2775)';
export const productCompare = {
    maxProducts: 'Maximum (4) items selected',
    compareNow: 'Compare Now >',
};
export const FORGOT_PASSWORD = 'Forgot Password';
export const THRESOLD_SAVEDITEMS = 50;
export const USER_STORE = 'userStore';
export const USER_STORE_INFO = 'userStoreInfo';
export const CARTPAGE_LAST_VISIT_TIME = 'cartPageLastVisitTime';

export const recommendationSourceType = {
    Certona: 'certona',
    Adobe: 'adobe',
    Criteo: 'criteo',
    GetAllSaveForLater: 'getAllSaveForLater',
    Source: 'rrplacementtype=',
    Home: 'HOME',
    Department: 'DEPARTMENT',
    HomeBrand: 'home-brand',
    DepBrand: 'dep-brand',
};

export const apiErrorLog = {
    genericError: {
        type: 'generic_api_error',
        description: 'generic api error',
    },
    statusCodeNot200: {
        type: 'api_status_code_not_200',
        description: 'api failed with status code',
    },
    emptyResponseData: {
        type: 'response_data_empty',
        description: 'api response data is empty',
    },
};

export const locationServiceCookies = {
    akamaiStore: 'akamaiStore',
    userPreferredStore: 'userPreferredStore',
    userStore: 'userStore',
};

export const plccBannerCards = {
    JCP_CARD: 'JCP',
    PLATINUM_TIER: 'platinum',
};

export const atcHeaderOptions = {
    ADDITIONAL_OPTIONS: 'Additional Options',
    DETAILS: 'Details',
};

export const headerStore = {
    NO_STORE_LOCATED: 'JCPenney Stores',
};

export const headerStoreSelectionSlider = {
    TITLE: 'Find a Pickup Store',
    visitStoreTitle: 'Check Store Availability',
};

export default {
    barcode: {
        modalTitle: 'Use Your Rewards',
        modalHeading:
            'To Redeem in-store, present barcode to the cashier. Some <a href="www.jcpenney.com">exclusions</a> may apply.',
        modalButtonTitle: 'Print',
        type: {
            JCPMASTER: ['MCCERT', 'MASTERCARD RWD'],
        },
        images: {
            MASTERCARD: '/static-account/assets/images/mc-vrt-pos.svg',
            BONUSBUCKS: '/static-account/assets/images/bonus-bucks-cert-header.svg',
            BG_LG_BONUSBUCKS: '/static-account/assets/images/bonus-bucks-bg-xl.svg',
        },
    },
    createAccountErrorMessages: {
        EMPTY_INPUT_ERROR: 'Please enter valid password',
        NON_ALLOWED_SPECIALS_ERROR: 'Not all special characters are allowed',
        MISC_CHARS_ERROR:
            'Password cannot have name, email, penney, jcp or jcpenney, 3+ consecutive characters',
        MINIMUM_REQ_NOT_MET_ERROR: 'Password does not meet requirements',
    },
    cookie: {
        // Cookie names
        LATLONG: '_userLoc',
        PRICE_ZONE: 'UPZ',
        previewDate: 'DP_PREVIEW_DATE',
    },
    findStoreErrorMessages: {
        LOCATION_ERROR_MSG_TITLE: 'Location services error',
        LOCATION_NOT_ENABLED:
            'Please enter your Zip Code or City, State, since location services are not enabled due to browser or privacy settings.',
        GEO_LOCATE_ERROR: 'There was an error with location services, please enter your location',
        EMPTY_ZIP_CODE: 'Please enter a valid zipcode or choose use my location',
        FUSION_EMPTY_ZIP_CODE: 'Please enter a valid zipcode',
        ZIP_CODE_ERROR: 'Zip code must be 5 digits',
    },
    geoErrorType: {
        GEO_LOCATE_ERROR: 'geoLocateError',
        GEO_UNAVAILABLE: 'geoUnavailable',
        EMPTY_ZIP_CODE: 'emptyZipCode',
        NOT_SUPPORTED: 'browserNotSupported',
        TIMED_OUT: 'timeout',
        AKAMAI_LOCATE_ERROR: 'AkamaiLocateError',
    },
    useLocationLabel: 'Use My Location',
    couponBodyCopy: 'Show coupon to sales associate',
    couponErrorMessages: {
        COUPON_CODE_MISSING: 'Please enter a valid code.',
        INPUT_BOX_PLACEHOLDER: 'Enter promo code...',
        CODE_DOES_NOT_EXIST: 'Code does not exist.',
        COUPON_REQUEST_ERROR:
            'Oops! There is an error on our end. Please try to apply the coupon again.',
        COUPON_CODE_EXPIRED:
            'Oh no! The code you typed in has already expired. Please apply an eligible coupon.',
        SRV_COUPON_EXPIRED_ERR:
            'Oh no! The code you typed in has already expired. Please apply an eligible coupon.',
        SERIAL_NUMBER_REQUIRED: 'Serial Number Required.',
        SERIAL_NUMBER_REQ_MESSAGE:
            'This code requires a serial number. Please type in the serial number shown on your coupon or reward.',
        IRIS_COUPON_NO_CART_ITEMS:
            'Oops! We cannot apply this coupon because your cart is empty. We can apply this coupon code once you add an item to your bag.',
        SRV_PROMOCODE_INVALID:
            'Oh no! The code you applied has already expired. Please apply an eligible coupon.',
    },
    COUPON_SUBTYPE_PROMOTIONAL: 'PROMOTIONAL',
    COUPON_SUBTYPE_SHIPPING: 'SHIPPING',
    COUPON_APPLIED_SUCCESS: 'This coupon has been applied to your cart.',
    CONTINUE_SHOPPING_LABEL: 'Continue Shopping',
    IRIS_CONTINUE_SHOPPING_LABEL: 'Shop Sales',
    COUPONS_APPLIED_LABEL: 'Coupon Applied',
    COUPONS_APPLIED_LABEL_EXCLUSION: 'Coupon Applied to Cart',
    COUPONS_UPDATE_LABEL: 'Coupon Updated',
    REWARDS_APPLIED_LABEL: 'Reward Applied',
    CHECKOUT_LABEL: 'Checkout',
    SERIAL_APPLY_LABEL: 'Apply Number',
    COUPONS_NO_CODE_REQUIRED: 'NO CODE NECESSARY',
    couponToggleDetails: {
        COUPONS_SHOW_DETAILS: 'Show Details',
        COUPONS_HIDE_DETAILS: 'Hide Details',
        IRIS_COUPON_DETAILS: 'see details',
    },
    COUPON_EMPTYCART_LABEL: 'Cannot Apply Coupon',
    IRIS_COUPON_EMPTYCART_LABEL: 'Your Cart is Empty',
    CouponCategory: {
        all: 'online & in store',
        inStore: 'in store only',
        onlineOnly: 'online only',
    },
    CouponCategories: {
        all: 'Online & In Store',
        instore: 'In Store Only',
        online: 'Online Only',
    },
    CouponTypes: {
        APPLIED: 'Applied',
        SERIAL: 'Serial',
        BARCODE: 'Barcode',
    },
    couponPrintCheck: ['print', 'print coupon'],
    adjustmentType: {
        COUPON: 'COUPON',
        REWARD: 'REWARDSCERT',
        FREESHIP: 'CouponSHFree',
        ASSOC_DISCOUNT: 'ASSOCIATEDISCOUNT',
    },
    CouponRedeemingChannel: {
        ALL: 'all',
        IN_STORE: 'instore',
        ONLINE_ONLY: 'online',
    },
    CouponFindStoreLabel: 'find a store',
    CouponShopNowLabel: 'shop now',
    CouponPrintLabel: 'Print',
    IRISCouponPrintLabel: 'Print Barcode',
    CouponAppledMethod: {
        INPUT_COUPON: 'manual',
        SELECT_COUPON: 'selected from list',
    },
    findStores: {
        order: {
            detailsButton: 'Select',
        },
        account: {
            detailsButton: 'Set My Store',
        },
        orderMessage: 'Same day pickup items ordered after 3 PM will be available the next day',
        newOrderMessage: 'Order by 3PM and get it today',
        noStoresMessage: "We're sorry...we couldn't find any jcp stores that match your search",
        noSDPUStoresTitle:
            'Sorry, there are no JCP stores in that location with the item(s) available for Same Day Pickup.',
        noSDPUStoresMessage:
            "We're sorry…there are no JCP stores in that location with the item(s) available for Same Day Pickup.",
        invalidInputMsg: 'Please enter valid city, state or ZIP code',
        INVALID_INPUT: 'INVALID_INPUT',
        LINK: 'Link',
        STORES_COUNT: 'X-Total-Count',
        // GOOGLE_API_KEY: 'AIzaSyAfusq-fyrNuqnEnMKl55b-63b70r8Uc5k', // Old key
        GOOGLE_API_KEY: 'AIzaSyCXssOmw3AgN0U-STMPbASl28ymrK4We2U',
        filterHeader: 'Filter by Services',
        noStorePageTitle: "Sorry, we couldn't find any stores near your search.",
        noStorePageContent: 'Please make sure you entered a valid zip code or city, state.',
        invalidInputContent: 'Please make sure you entered a valid zip code or city, state.',
        defaultTitle: 'Enter a City, State or Zip Code to find the closest JCPenney store.',
        findAStorePageTitle: 'Find A Store',
        selectAStorePageTitle: 'Select A Store',
        changeMyStorePageTitle: 'Change My Store',
    },
    searchMaps: {
        GOOGLE_MAPS_URL: 'https://www.google.com/maps/dir/?api=1&destination=',
        APPLE_MAPS_URL: 'https://maps.apple.com?address=',
    },
    GENERIC_API_ERROR_MESSAGE:
        'There was an error while processing your request. Please try again.',
    COUPON_TYPEAHEAD_TRIGGER_LENGTH: 3,
    IN_STORE_ONLY_COUPONS: 'INSTOREONLYCOUPONS',
    ACCESS_TOKEN: 'Access_Token',
    REFRESH_TOKEN: 'Refresh_Token',
    ACCOUNT_ID: 'ACCOUNT_ID',
    DP_USER_STATE: 'DP_USER_STATE',
    DP_FIRST_NAME: 'DP_FIRST_NAME',
    DP_USER_NAME: 'DP_USER_NAME',
    DP_REWARDS_STATUS: 'DP_REWARDS_STATUS',
    DP_REWARDS_CERTS: 'DP_REWARDS_CERTS',
    DP_SAVED_ITEMS_COUNT: 'DP_SAVED_ITEMS_COUNT',
    DP_SAVED_ITEMS: 'DP_SAVED_ITEMS',
    ANALY_CUST_STATE: 'ANALY_CUST_STATE',
    ANALY_LOGIN: 'logged-in',
    ANALY_GUEST: 'guest',
    ANALY_LOGIN_RECOG: 'logged-in|recognized',
    ANALY_RECOG_LOGIN: 'recognized|logged-in',
    ANALY_RECOG_GUEST: 'recognized|guest',
    DP_CHECKOUT_SAVED_ITEMS: 'DP_CHECKOUT_SAVED_ITEMS',
    DP_CHECKOUT_SAVED_ITEMS_PAYLOAD: 'DP_CHECKOUT_SAVED_ITEMS_PAYLOAD',
    DP_USER_TOKEN: 'DP_USER_TOKEN',
    DP_SAVED_ITEMS_PAYLOAD: 'DP_SAVED_ITEMS_PAYLOAD',
    DP_VISITOR_ID: 'DP_VISITOR_ID',
    DP_USER_DEFAULT_STORE: 'DP_USER_DEFAULT_STORE',
    DEFAULT_STORE: 'defaultStore',
    DP_SFL_ID: 'DP_SFL_ID',
    TOKEN_API_STATUS: 'TOKEN_API_STATUS',
    DEFAULT_CURRENCY: 'USD',
    ITEM_COUNT: 'ItemCount',
    DESKTOP_ITEM_COUNT: 'DP_ORDER_INFO',
    DP_FULL_ACCESS_EXPIRY: 'DP_FULL_ACCESS_EXPIRY',
    analytics: {
        COUPON_APPLIED_SUCCESS: 'COUPON_APPLIED_SUCCESS',
        SELECT_STORE_SUCCESS: 'SELECT_STORE_SUCCESS',
    },
    branchio: {
        BRANCHIO_TEST_KEY: 'key_test_mlBoOH9ybO7NGpeCWvvNTegaBtev2hgv',
        BRANCHIO_LIVE_KEY: 'key_live_ekymMOXuhN0OGkfD1ytRmhmluEozYgdl',
    },
    OK_LABEL: 'OK',
    CART_PAGE_URL: '/cart',
    CHECKOUT_PAGE_URL: '/checkout',
    ACCOUNT_LOCKED_PAGE_URL: '/checkout/account-locked',
    CART_YODA_EXPERIENCE: 'OFF',
    CLASSIC_CART_PAGE_URL: '/cart#/',
    // =Constants for error message handling. Don't remove them,
    SET_SERVICE_ERROR: 'SET_SERVICE_ERROR',
    CLEAR_SERVICE_ERROR: 'CLEAR_SERVICE_ERROR',
    GENERIC_API_ERROR: 'GENERIC_API_ERROR',
    INITIATE_CHECKOUT_AGAIN: 'INITIATE_CHECKOUT_AGAIN',
    SRV_ITEM_NOT_FOUND: 'SRV_ORD_ERR_ITM_NF',
    SRV_COMMERCE_ITEMNOTFOUND: 'SRV_COMMERCE_ITEMNOTFOUND',
    SRV_PROMOTION_NOTFOUND: 'SRV_PROMOTION_NOTFOUND',
    ACTION_NOT_ALLOWED_FOR_RECOGNIZED: 'ACTION_NOT_ALLOWED_FOR_RECOGNIZED',
    SRV_BILLING_ADDRESS_INVALID: 'SRV_BILLING_ADDRESS_INVALID',
    SRV_ORDER_EMAILNOTFOUND: 'SRV_ORDER_EMAILNOTFOUND',
    findStoreThemes: {
        findAStorePage: 'findAStorePage',
        gallery: 'gallery',
        selectAStore: 'selectAStore',
        pdpMajorAppliances: 'pdpMajorAppliances',
        visitStoreToPurchase: 'visitStoreToPurchase',
        pdp: 'pdp',
    },
    SRV_PRODUCT_NOTFOUND: 'SRV_PRODUCT_NOTFOUND',
    SRV_REFRESH_TOKEN_EXPIRED: 'SRV_REFRESH_TOKEN_EXPIRED',
    GUEST_USER: 'GUEST_USER',
    APPLIANCE_MESSAGE_TITLE:
        'Major Appliances are available for purchase nationwide. You can place an order on jcp.com, in an area store(see below), or call 1-844-JCP-APPL(1-844-527-2775)',
    productCompare: {
        maxProducts: 'Maximum (4) items selected',
        compareNow: 'Compare Now >',
    },
    THRESOLD_SAVEDITEMS: 50,
    USER_STORE: 'userStore',
    USER_STORE_INFO: 'userStoreInfo',
};
